<template>
  <v-container fluid class="salesorder-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab :href="`#tab-salesorder`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Order
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-items`" >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-files`">
            <v-icon class="mr-3">mdi-file-multiple</v-icon>
            Files
          </v-tab>
          <v-tab-item :value="'tab-salesorder'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Sales Order</p>
                      <v-text-field
                        :readonly="isNotEditable"
                        class="mb-4"
                        type="number"
                        v-model="edit_salesorder.salesordernum"
                        v-on:change="
                          onChangeOrder($event, 'salesordernum')
                        "
                        outlined
                        dense
                        placeholder="Order Num"
                        persistent-hint
                        single-line
                        hint="Enter the order num"
                      >
                      </v-text-field>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="salesordertype"
                        v-model="edit_salesorder.salesordertype"
                        v-on:change="onChangeOrder($event, 'salesordertype')"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the sales order type"
                      >
                      </v-select>
                      <v-menu
                        ref="menu_salesorderdate"
                        v-model="menu_salesorderdate"
                        :close-on-content-click="false"
                        :return-value.sync="edit_salesorder.salesorderdate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            dense
                            class="mb-4"
                            v-model="edit_salesorder.salesorderdate"
                            label="Order Date"
                            v-bind="attrs"
                            v-on:change="onChangeOrder($event, 'salesorderdate')"
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            persistent-hint
                            hint="Please choose the order date"
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          v-model="salesorderdate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_salesorderdate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="onChangeOrder(salesorderdate,'salesorderdate'); $refs.menu_salesorderdate.save(salesorderdate);"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-menu
                        ref="menu_salesorderduedate"
                        v-model="menu_salesorderduedate"
                        :close-on-content-click="false"
                        :return-value.sync="edit_salesorder.salesorderduedate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            dense
                            class="mb-4"
                            v-model="edit_salesorder.salesorderduedate"
                            label="Due Date"
                            v-bind="attrs"
                            v-on:change="onChangeOrder($event, 'salesorderduedate')"
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            persistent-hint
                            hint="Please choose the due date"
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          v-model="salesorderduedate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_salesorderduedate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="onChangeOrder(salesorderduedate,'salesorderduedate'); $refs.menu_salesorderduedate.save(salesorderduedate);"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="locations.map(x => {return {text: x.locationname, value: x._id};})"
                        v-model="edit_salesorder.locationid"
                        v-on:change="onChangeOrder($event, 'locationid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>
                      <v-switch
                        color="primary"
                        v-on:change="onChangeOrder($event, 'isTaxable')"
                        v-model="edit_salesorder.isTaxable"
                        v-bind:value="edit_salesorder ? edit_salesorder.isTaxable : false"
                        hint="Taxable"
                        persistent-hint
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" v-if="edit_salesorder.salesordertype!='Daily Sales'">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        :readonly="isNotEditable"
                        class="mb-4"
                        append-icon="mdi-magnify"
                        placeholder="Customer Name"
                        single-line hint="Select the Customer"
                        v-on:change="onChangeOrder($event, 'salesordername')"
                        outlined
                        dense
                        @click:append="searchCustomerDialog"
                        persistent-hint
                        v-model="edit_salesorder.salesordername"
                        v-bind:error="errorindex == 3"
                      >
                      </v-text-field>  
                      <v-textarea
                        :readonly="isNotEditable"
                        outlined
                        v-model="edit_salesorder.salesorderaddress"
                        v-on:change="
                          onChangeOrder($event, 'salesorderaddress')
                        "
                        rows="2"
                        label="Address"
                        hint="please enter the customer address"
                      ></v-textarea>
                      <v-row no-gutters>
                        <v-col cols="12" md="6" class="mb-0 pr-1">
                          <v-text-field
                            :readonly="isNotEditable"
                            class="mb-4"
                            v-model="edit_salesorder.salesorderphone"
                            v-on:change="
                              onChangeOrder($event, 'salesorderphone')
                            "
                            outlined
                            v-bind:error="errorindex == 11"
                            dense
                            placeholder="Phone"
                            persistent-hint
                            single-line
                            hint="Enter the phone"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="mb-0 pr-1">
                          <v-text-field
                            :readonly="isNotEditable"
                            class="mb-4"
                            v-model="edit_salesorder.salesordermobile"
                            v-on:change="
                              onChangeOrder($event, 'salesordermobile')
                            "
                            v-bind:error="errorindex == 12"
                            outlined
                            dense
                            placeholder="Mobile"
                            persistent-hint
                            single-line
                            hint="Enter the mobile phone"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>


                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="regions.map(x => {return {text: x.regionname, value: x._id};})"
                        v-model="edit_salesorder.regionid"
                        v-on:change="onChangeOrder($event, 'regionid')"
                        v-bind:error="errorindex == 8"
                        outlined
                        dense
                        placeholder="Region"
                        persistent-hint
                        single-line hint="Please choose the region">
                      </v-select>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="townships.filter(x=>x.regionid==edit_salesorder.regionid).map((x) => {return { text: x.townshipname, value: x._id };})"
                        v-model="edit_salesorder.townshipid"
                        v-on:change="onChangeOrder($event, 'townshipid')"
                        v-bind:error="errorindex == 3"
                        outlined
                        dense
                        placeholder="Township"
                        persistent-hint
                        single-line
                        hint="Please choose the township"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" v-if="edit_salesorder.salesordertype!='Daily Sales'">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="saleschannels.map(x => {return {text: x.channelname, value: x._id};})"
                        v-model="edit_salesorder.channelid"
                        v-on:change="onChangeOrder($event, 'channelid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Channel"
                        persistent-hint
                        single-line hint="Please choose the channel">
                      </v-select>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="pricelists.filter(x => x.channelid==edit_salesorder.channelid).map(x => {return {text: x.pricelistname, value: x._id};})"
                        :value="edit_salesorder.pricelistid"
                        v-on:change="onChangeOrder($event, 'pricelistid')"
                        outlined
                        dense
                        placeholder="Price List"
                        persistent-hint
                        single-line hint="Please choose the pricelist">
                      </v-select>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="users.filter(user=>user.userstatus=='Active').map(x => {return {text: x.username, value: x._id};})"
                        v-model="edit_salesorder.userid"
                        v-on:change="onChangeOrder($event, 'userid')"
                        v-bind:error="errorindex == 7"
                        outlined
                        dense
                        placeholder="Sales Rep"
                        persistent-hint
                        single-line hint="Please choose the sales rep">
                      </v-select>

                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="salesorderpayterms"
                        v-model="edit_salesorder.salesorderpayterms"
                        v-on:change="onChangeOrder($event, 'salesorderpayterms')"
                        v-bind:error="errorindex == 5"
                        outlined
                        dense
                        placeholder="Pay Terms"
                        persistent-hint
                        single-line
                        hint="Please choose the pay terms"
                      >
                      </v-select>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="paymethods.map(x => {return {text: x.paymethodname, value: x._id};})"
                        v-model="edit_salesorder.paymethodid"
                        v-on:change="onChangeOrder($event, 'paymethodid')"
                        v-bind:error="errorindex == 11"
                        outlined
                        dense
                        placeholder="Payment Method"
                        persistent-hint
                        single-line hint="Please choose the payment method">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" v-if="edit_salesorder.salesordertype!='Daily Sales'">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-row no-gutters>
                        <v-col cols="12" md="6" class="mb-3 pr-1">
                          <v-select
                            :readonly="isNotEditable"
                            :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                            v-on:change="onChangeOrder($event, 'primaryCurrency')"
                            v-bind:value="edit_salesorder.primaryCurrency"
                            v-bind:error="errorindex == 11"
                            outlined
                            dense
                            placeholder="Currency 1"
                            persistent-hint
                            single-line hint="Currency 1">
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="6" class="mb-3 pl-1">
                          <v-select
                            :readonly="isNotEditable"
                            :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                            v-on:change="onChangeOrder($event, 'secondaryCurrency')"
                            v-bind:error="errorindex == 12"
                            v-bind:value="edit_salesorder.secondaryCurrency"
                            outlined
                            dense
                            placeholder="Currency 1"
                            persistent-hint
                            single-line hint="Currency 2">
                          </v-select>
                        </v-col>
                        <v-text-field
                          :readonly="isNotEditable"
                          class="mb-3"
                          v-bind:value="edit_salesorder.currencyRate"
                          v-bind:error="errorindex == 13"
                          v-on:change="onChangeOrder($event, 'currencyRate')"
                          outlined
                          dense
                          placeholder="Rate"
                          persistent-hint
                          single-line hint="Enter the currency rate">
                        </v-text-field>
                      </v-row>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Credit', 'Pending', 'Partial', 'Completed', 'Audit', 'Void']"
                        :value="edit_salesorder.salesorderstatus"
                        v-on:change="onChangeOrder($event, 'salesorderstatus')"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line
                        hint="Please choose the status"
                      >
                      </v-select>
                      <v-textarea
                        :readonly="isNotEditable"
                        v-model="edit_salesorder.salesordernote"
                        v-on:change="onChangeOrder($event, 'salesordernote')"
                        outlined
                        rows=5
                        label="Note"
                        hint="please enter the note"
                      ></v-textarea>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" v-else>
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                        <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="saleschannels.map(x => {return {text: x.channelname, value: x._id};})"
                        v-model="edit_salesorder.channelid"
                        v-on:change="onChangeOrder($event, 'channelid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Channel"
                        persistent-hint
                        single-line hint="Please choose the channel">
                      </v-select>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="pricelists.filter(x => x.channelid==edit_salesorder.channelid).map(x => {return {text: x.pricelistname, value: x._id};})"
                        :value="edit_salesorder.pricelistid"
                        v-on:change="onChangeOrder($event, 'pricelistid')"
                        outlined
                        dense
                        placeholder="Price List"
                        persistent-hint
                        single-line hint="Please choose the pricelist">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Credit', 'Pending', 'Partial', 'Completed', 'Audit', 'Void']"
                        :value="edit_salesorder.salesorderstatus"
                        v-on:change="onChangeOrder($event, 'salesorderstatus')"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line
                        hint="Please choose the status"
                      >
                      </v-select>
                      <v-textarea
                        :readonly="isNotEditable"
                        v-model="edit_salesorder.salesordernote"
                        v-on:change="onChangeOrder($event, 'salesordernote')"
                        outlined
                        rows=5
                        label="Note"
                        hint="please enter the note"
                      ></v-textarea>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/salesorder/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="updateSalesOrder()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <p class="text-h5">Items</p>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="6" class="d-flex flex-end justify-md-end overflow-auto" align="right">
                    <v-btn
                      v-show="!isNotEditable"
                      class="button-shadow mr-1"
                      color="success"
                      @click="isAddTransaction=true; add_transaction={};">
                      Add
                    </v-btn>
                    <v-btn
                      class="button-shadow mr-1"
                        to="/salesorder/list"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                  </v-col>
                  <v-col md="2" align="right">
                  </v-col>
                </v-row>
                <v-data-table
                  :headers="header_items"
                  :items="transactions"
                  :items-per-page="500"
                  :footer-props="footer"
                  class="elevation-0"
                >
                  <template v-slot:top>
                    <v-dialog v-model="isDeleteTransaction" width="500">
                      <v-card>
                        <v-card-title> Delete this Item? </v-card-title>
                        <v-card-text>
                          {{ delete_transaction.itemname }}
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            outlined
                            @click="isDeleteTransaction = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="secondary"
                            class="button-shadow"
                            @click="deleteTransaction(delete_transaction)"
                          >
                            Delete
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                  <template v-slot:item.itemimage="{ item }">
                    <v-img
                      v-bind:lazy-src="item.itemimage"
                      min-width="50"
                      max-width="100"
                      v-bind:src="item.itemimage"
                    ></v-img>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      v-if="!isNotEditable"
                      icon
                      color="primary"
                      @click="updateTransactionDialog(item)"
                    >
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="!isNotEditable"
                      icon
                      color="primary"
                      @click="deleteTransactionDialog(item)"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-files'">
            <FileEditView :id="initvalue._id" :route="`salesorder`" :files="files" />
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>

              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="brands.filter(brand=>brand.brandtype=='Brand').map(x => {
                      return {text: x.brandname, value: x._id};
                    })"
                    v-model="add_transaction.brandid"
                    v-bind:error="errorindex == 2"
                    dense
                    placeholder="Brand"
                    persistent-hint
                    single-line hint="Brand">
                  </v-select>
                </v-col>
                <v-col cols="12" md="8">
                  <v-select
                    class="mb-4"
                    :items="items.filter(item=>item.brandid == add_transaction.brandid).map(x => {
                      return {text: x.itemname, value: x._id};
                      })"
                    v-model="add_transaction.itemid"
                    v-bind:error="errorindex == 0"
                    v-on:change="onChangeItem"
                    dense
                    placeholder="Item"
                    persistent-hint
                    single-line hint="Item">
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="add_transaction.itemquantity"
                    class="mb-4"
                    dense
                    placeholder="Qty"
                    persistent-hint
                    type="number"
                    v-on:input="onChangeQuantity"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line hint="Quantity">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-select
                    class="mb-4"
                    :items="['', 'Foc', 'Promo']"
                    v-model="add_transaction.itemfoc"
                    v-on:change="onChangeFoc"
                    dense
                    placeholder="Free"
                    persistent-hint
                    single-line
                    hint="Free"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    :readonly="add_transaction.itemfoc=='Foc' || add_transaction.itemfoc=='Promo'"
                    type="number"
                    v-model="add_transaction.itemprice"
                    class="mb-4"
                    dense
                    placeholder="Prc"
                    v-on:input="onChangePrice"
                    persistent-hint
                    single-line hint="Price">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    v-model="add_transaction.itemamount"
                    class="mb-4"
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="insertTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>

              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="brands.filter(brand=>brand.brandtype=='Brand').map(x => {
                      return {text: x.brandname, value: x._id};
                    })"
                    v-model="edit_transaction.brandid"
                    v-bind:error="errorindex == 2"
                    dense
                    placeholder="Brand"
                    persistent-hint
                    single-line hint="Brand">
                  </v-select>
                </v-col>
                <v-col cols="12" md="8">
                  <v-select
                    class="mb-4"
                    :items="items.filter(item=>item.brandid == edit_transaction.brandid).map(x => {
                      return {text: x.itemname, value: x._id};
                      })"
                    v-model="edit_transaction.itemid"
                    v-bind:error="errorindex == 0"
                    v-on:change="onChangeItemEdit"
                    dense
                    placeholder="Item"
                    persistent-hint
                    single-line hint="Item">
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="edit_transaction.itemquantity"
                    class="mb-4"
                    dense
                    placeholder="Qty"
                    persistent-hint
                    type="number"
                    v-on:input="onChangeQuantityEdit"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line hint="Quantity">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-select
                    class="mb-4"
                    :items="['', 'Foc', 'Promo']"
                    v-model="edit_transaction.itemfoc"
                    v-on:change="onChangeFocEdit"
                    dense
                    placeholder="Free"
                    persistent-hint
                    single-line
                    hint="Free"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    type="number"
                    :readonly="edit_transaction.itemfoc=='Foc' || edit_transaction.itemfoc=='Promo'"
                    v-model="edit_transaction.itemprice"
                    class="mb-4"
                    dense
                    placeholder="Prc"
                    v-on:input="onChangePriceEdit"
                    persistent-hint
                    single-line hint="Price">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    v-model="edit_transaction.itemamount"
                    class="mb-4"
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';
import router from "@/Routes";
import FileEditView from "@/pages/File/Components/FileEditView.vue";

export default {
  components: {
    FileEditView
  },
  data() {
    return {
      header_items: [
        { text: "Image", value: "itemimage" },
        { text: "Name", value: "itemname" },
        { text: 'Foc', value: 'itemfoc', width: '5%' },
        { text: 'Qty', value: 'itemquantity', width: '10%'},
        { text: 'Prc', value: 'itemprice', width: '10%'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
        { text: "Actions", value: "actions", sortable: false },
      ],
      header_files: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      initvalue: {},
      edit_salesorder: {},
      add_transaction: {},
      edit_transaction: {},
      
      delete_transaction: {},
      change_salesorder: {},

      delete_file: {},
      trade: {},
      search_customer: {},

      isDeleteFile: false,
      isDeleteTransaction: false,
      isAddTransaction: false,
      isEditTransaction: false,
      isUploadFile: false,

      upload: {filename: null,file: null},
      transactions: [],
      files: [],
      images: [],
      salesordertype: ["Sales Order", "Cash Order", "Credit Order", "Pre Order", "Daily Sales"],
      salesorderpayterms: ["Cash", "Credit 15 Days", "Credit 30 Days"],
    
      filename: null,
      uploadname: null,

      route: 0,
      footer: {'items-per-page-options': [500, 1000, 5000]},

      brandid: undefined,
      price: undefined,

      
      salesorderdate: null,
      salesorderduedate: null,
      menu_salesorderdate: false,
      menu_salesorderduedate: false,
  
      errorindex: undefined,
    };
  },
  computed: {
    ...mapState("Brand", ["brands"]),
    ...mapState("Customer", ["customers"]),
    ...mapState("Item", ["items"]),
    ...mapState("Location", ["locations"]),
    ...mapState("PayMethod", ["paymethods"]),
    ...mapState("Price", ["prices"]),
    ...mapState("PriceList", ["pricelists"]),
    ...mapState("Region", ["regions"]),
    ...mapState("SalesChannel", ["saleschannels"]),
    ...mapState("Township", ["townships"]),
    ...mapState("SalesOrder", ["isReceiving"]),
    ...mapState("User", ["users"]),
    isNotEditable(){
      let result = ['New','Credit','Partial','Pending','Audit','Void'].indexOf(this.initvalue.salesorderstatus) == -1;
      return result;
    }
  },
  methods: {
    ...mapActions("Brand", ["getBrandsRequest"]),
    ...mapActions("Customer", ["getCustomersRequest"]),
    ...mapActions("Item", ["getItemsRequest"]),
    ...mapActions("Location", ["getLocationsRequest"]),
    ...mapActions("PayMethod", ["getPayMethodsRequest"]),
    ...mapActions("Price", ["getPricesRequest"]),
    ...mapActions("PriceList", ["getPriceListsRequest"]),
    ...mapActions("Region", ["getRegionsRequest"]),
    ...mapActions("SalesChannel", ["getSalesChannelsRequest"]),
    ...mapActions("SalesOrder", ["deleteSOTransactionRequest", "getSalesOrderRequest", "insertSOTransactionRequest", "updateSalesOrderRequest", "updateSalesOrderTransaction", "updateSalesOrderTrade",]),
    ...mapActions("Township", ["getTownshipsRequest"]),
    ...mapActions("User", ["getUsersRequest"]),
    clearTransaction() {
      let brandid = this.add_transaction.brandid;
      this.add_transaction = {brandid: brandid};
    },
    deleteTransactionDialog(item) {
      this.isDeleteTransaction = true;
      this.delete_transaction = {_id: item._id, itemname: item.itemname, itemquantity: item.itemquantity};
    },
    async deleteTransaction(payload) {
      this.isDeleteTransaction = false;
      let response = await this.deleteSOTransactionRequest(payload);
      let index = this.transactions.findIndex((trans) => trans._id == response._id);
      this.transactions.splice(index, 1);
      this.getSalesOrderRequest(this.initvalue._id);
    },

    async insertTransaction() {
      this.isAddTransaction = false;
      if(this.add_transaction.itemid==null || this.add_transaction.itemprice==null || this.add_transaction.itemamount==null) return;
      let payload = Object.assign({}, this.add_transaction, {salesorderid: this.initvalue._id});
      let response = await this.insertSOTransactionRequest(payload);
      this.transactions.push(response);
      this.clearTransaction();
      this.getSalesOrderRequest(this.initvalue._id);
    },
    findPriceByQuantity(prices, itemid, qty){
      let price = prices.find(price=> price.itemid==itemid && parseInt(qty)>=price.minqty && parseInt(qty)<=price.maxqty);
      return price;
    },

    onChangeFile(file) {
      if (!file) this.upload.file = null;
      else this.upload.file = file;
    },
    onChangeOrder(value, field) {
      this.change_salesorder[field] = value;
    },
    onChangeItem(itemid){
      let item = this.items.find(item=>item._id == itemid);
      let pricelist = this.pricelists.find(list=>list._id==this.initvalue.pricelistid);
      if(!this.add_transaction.itemquantity) this.add_transaction.itemquantity = 1;
      let price = this.findPriceByQuantity(pricelist.prices, item._id, this.add_transaction.itemquantity)
      let update = {
        itemid: item._id,
        itemimage: item.itemimage, 
        itemname: item.itemname,
        itemquantity: this.add_transaction.itemquantity,
        itemprice: price!=null ? price.listprice : 0,
      }
      update.itemamount = update.itemprice * update.itemquantity;
      this.add_transaction = Object.assign({}, this.add_transaction, update);
      this.onChangeQuantity();
    },
    onChangeItemEdit(itemid){
      let item = this.items.find(item=>item._id == itemid);
      let pricelist = this.pricelists.find(list=>list._id==this.initvalue.pricelistid);
      if(!this.edit_transaction.itemquantity) this.edit_transaction.itemquantity = 1;
      let price = this.findPriceByQuantity(pricelist.prices, item._id, this.edit_transaction.itemquantity);
      let update = {
        itemid: item._id,
        itemimage: item.itemimage, 
        itemname: item.itemname,
        itemquantity: this.edit_transaction.itemquantity,
        itemprice: price!=null ? price.listprice : 0,
      }
      update.itemamount = update.itemprice * update.itemquantity;
      this.edit_transaction = Object.assign({}, this.edit_transaction, update);
      this.onChangeQuantityEdit();
    },
    onChangeQuantity(){
      let update = {};
      update.itemamount =  this.add_transaction.itemquantity * this.add_transaction.itemprice;
      this.add_transaction = Object.assign({}, this.add_transaction, update);
    },
    onChangeQuantityEdit(){
      let update = {};
      update.itemamount =  this.edit_transaction.itemquantity * this.edit_transaction.itemprice;
      this.edit_transaction = Object.assign({}, this.edit_transaction, update);
    },
    onChangePrice(){
      let update = {
        itemamount: this.add_transaction.itemprice * this.add_transaction.itemquantity,
      };
      this.add_transaction = Object.assign({}, this.add_transaction, update);
    },
    onChangePriceEdit(){
      let update = {
        itemamount: this.edit_transaction.itemprice * this.edit_transaction.itemquantity,
      };
      this.edit_transaction = Object.assign({}, this.edit_transaction, update);
    },
    onChangeFoc(foc){
      if(foc=='') this.onChangeItem(this.add_transaction.itemid);
      else{
          let update = {
          itemprice: 0,
          itemamount: 0 * this.add_transaction.itemquantity,
        };
        this.add_transaction = Object.assign({}, this.add_transaction, update);
      }
    },
    onChangeFocEdit(foc){
      if(foc=='') this.onChangeItem(this.edit_transaction.itemid);
      else{
          let update = {
          itemprice: 0,
          itemamount: 0 * this.edit_transaction.itemquantity,
        };
        this.edit_transaction = Object.assign({}, this.edit_transaction, update);
      }
    },
    onUploadChange(file) {
      if (!file) {return;}
      this.upload.itemimage = file;
      this.upload.imagename = file.name;
    },
    searchCustomerDialog(){
      this.search_customer = {};
      this.isSearchCustomer = true;
    },
    async updateSalesOrder() {
      console.log('change',this.change_salesorder);
      this.change_salesorder._id = this.initvalue._id;
      await this.updateSalesOrderRequest(this.change_salesorder);
      router.push("/salesorder/list");
    },
    updateTransactionDialog(item){
      let edit = {
        _id: item._id,
        brandid: item.brandid,
        itemid: item.itemid,
        itemimage: item.itemimage,
        itemname: item.itemname,
        itemprice: item.itemprice,
        itemfoc: item.itemfoc,
        itemquantity: item.itemquantity,
        itemamount: item.itemamount,
      }
      this.edit_transaction = Object.assign({}, edit);
      this.isEditTransaction = true;
    },
    async updateTransaction() {
      this.isEditTransaction = false;
      let response = await this.updateSalesOrderTransaction(this.edit_transaction);
      let index = this.transactions.findIndex((x) => x._id == response._id);
      this.transactions.splice(index, 1, response);
      this.edit_transaction = {};
      this.getSalesOrderRequest(this.initvalue._id);
    },
  },

  async created() {
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.push({ name: "SalesOrderList" });
    this.edit_salesorder = Object.assign({}, this.initvalue);
    this.edit_salesorder.salesorderdate = formatStdDate(this.edit_salesorder.salesorderdate);
    this.edit_salesorder.salesorderduedate = formatStdDate(this.edit_salesorder.salesorderduedate);

    let result = await this.getSalesOrderRequest(this.initvalue._id);
    this.transactions = Object.assign([], result.transactions);
    this.files = Object.assign([], result.files);
    this.images = Object.assign([], result.images);

    if (this.brands.length==0) await this.getBrandsRequest();
    if (this.customers.length==0) await this.getCustomersRequest();
    if (this.items.length==0) await this.getItemsRequest();
    if (this.locations.length==0) await this.getLocationsRequest();
    if (this.paymethods.length==0) await this.getPayMethodsRequest();
    if (this.prices.length==0) await this.getPricesRequest();
    if (this.pricelists.length==0) await this.getPriceListsRequest();
    if (this.regions.length==0) await this.getRegionsRequest();
    if (this.saleschannels.length==0) await this.getSalesChannelsRequest();
    if (this.townships.length==0) await this.getTownshipsRequest();
    if (this.townships.length==0) await this.getUsersRequest();
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
